import { ProductName } from './base.definitions';
import { ElevioArticleIDs } from './elevio.definitions';

export class Environment {
    Version: string = 'local';
    Build: string = 'served';
    Branch?: string;

    Application!: {
        BaseUrls: {
            Api?: string,
            App?: string,
        },

        PortalName?: string;
        ProductName?: ProductName,
        ProductionMode?: boolean,

        Hostname?: string,
        WebsiteBase?: string,
        BaseHref?: string,

        LoginURL?: string,
        LogoutURL?: string,
        ImpersonatingLogoutURL?: string,

        LanguagesSupported?: string[],
    }

    Authentication!: {
        Portal: string,
        PrimaryToken?: string,
        SecondaryToken?: string,
    }

    Help?: {
        VirtualHelperURL?: string,
        ExternalCalendarFeedsHelpURL?: string,
        Elevio?: {
            Active?: boolean,
            ElevioID?: string,
            ArticleIDs?: ElevioArticleIDs,
            Hidden?: number[],
            Disabled?: number[],
        }
    }

    Payment? : {
        Stripe?: {
            PublicKey?: string,
            TeacherPaymentMethodConfigurationKey?: string,
            DefaultPaymentMethodConfigurationKey?: string,
        },
        PayPalCommercePlatform?: {
            ClientID?: string,
            BNCode?: string,
        }
    }

    Telemetry? : {
        GoogleAnalytics?: {
            ID?: string,
        },
        Clarity?: {
            ProjectID?: string,
        },
        Intercom?: {
            AppID?: string,
        },
        reCAPTCHA?: {
            SiteKey?: string
        },
    }

    constructor(initializer?: Partial<Environment>) {
        if (initializer) {
            Object.assign(this, initializer);
        }

        //Fill in dependand data
        this.Application.LoginURL = `${this.Application.BaseUrls.App}/Default.aspx`;
        this.Application.LogoutURL = `${this.Application.BaseUrls.App}/Default.aspx/Logout`;
        this.Application.ImpersonatingLogoutURL = `${this.Application.BaseUrls.App}/Default.aspx/ImpersonatingLogout`;
    }
}

//Authentication overrides
export const TeacherPortalAuthenticationOverrides = {
    Authentication: {
        Portal: 'TeacherPortal',
        PrimaryToken: "TeacherPortalAuth",
        SecondaryToken: "StudentPortalAuth"
    }
}

export const TeacherPortalBaseHrefOverride = '/Teacher/v2/';

export const StudentPortalAuthenticationOverrides = {
    Authentication: {
        Portal: 'StudentPortal',
        PrimaryToken: "StudentPortalAuth",
        SecondaryToken: "TeacherPortalAuth"
    }
}


export const PaymentPortalAuthenticationOverrides = {
    Authentication: {
        Portal: 'PaymentPortal',
        PrimaryToken: "StudentPortalAuth"
    }
}

export const WebsitePortalAuthenticationOverrides = {
    Authentication: {
        Portal: 'WebsitePortal'
    }
}

export const DisableHelpOverrides = {
    Help: {}
}

export enum EnvironmentVersion {
    EarlyAdopter = "beta",
    Main = "main"
}
